import { AxiosInstance } from "axios";
import {
  CREATED_PARTY_PATH,
  REQUEST_PARTY_PATH,
  REQUESTED_PARTY_PATH,
  JOINED_PARTY_PATH,
  ACCEPTED_REQUEST_USER_PATH,
  DECLINED_REQUEST_USER_PATH,
} from "../lib/path";
import {
  PartyListProps,
  RequestPartyListProps,
} from "../interfaces/PartyInterface";
import BaseUseCase from "../lib/BaseUseCase";

class AccountUseCase extends BaseUseCase {
  constructor(client: AxiosInstance) {
    super(client);
  }

  async getCreatedParties() {
    const config = this.getConfigHeaders();

    try {
      const response = await this.client.get(CREATED_PARTY_PATH, config);
      console.log(response.data);

      return response.data;
    } catch (error) {
      return error.response.data;
    }
  }

  async getJoinedParties() {
    const config = this.getConfigHeaders();

    try {
      const response = await this.client.get(JOINED_PARTY_PATH, config);

      return response.data;
    } catch (error) {
      return error.response.data;
    }
  }

  async getRequestParties() {
    const config = this.getConfigHeaders();

    try {
      const response = await this.client.get(REQUEST_PARTY_PATH, config);

      return response.data;
    } catch (error) {
      return error.response.data;
    }
  }

  async getRequestedParties() {
    const config = this.getConfigHeaders();

    try {
      const response = await this.client.get(REQUESTED_PARTY_PATH, config);

      return response.data;
    } catch (error) {
      return error.response.data;
    }
  }

  async acceptUserRequest(partyId, acceptedUserId) {
    const config = this.getConfigHeaders();

    try {
      const response = await this.client.post(
        ACCEPTED_REQUEST_USER_PATH,
        {
          party_id: partyId,
          accepted_user_id: acceptedUserId,
        },
        config
      );

      return response.data;
    } catch (error) {
      return error.response.data;
    }
  }

  async declineUserRequest(partyId, declinedUserId) {
    const config = this.getConfigHeaders();

    try {
      const response = await this.client.post(
        DECLINED_REQUEST_USER_PATH,
        {
          party_id: partyId,
          declined_user_id: declinedUserId,
        },
        config
      );

      return response.data;
    } catch (error) {
      return error.response.data;
    }
  }
}

export default AccountUseCase;
